export class Accordion {
    el;
    header;
    parent;
    content;
    constructor(settings) {
        this.el = settings.selector;
        this.header = settings.selector.querySelector(settings.trigger);
        this.parent = this.el.parentElement;
        this.content = this.el.querySelector('.accordion-content');
        if (this.content) {
            this.content.style.height = this.content.scrollHeight + 'px';
        }
        this.bind();
    }
    bind() {
        if (this.header) {
            this.header.addEventListener('click', e => {
                e.preventDefault();
                const isExpanded = this.header.getAttribute('aria-expanded') == 'true';
                this.toggle(isExpanded);
            });
            this.header.addEventListener('keydown', (e) => {
                e.preventDefault();
                const target = e.target;
                const key = e.which.toString();
                const ctrlModifier = (e.ctrlKey && key.match(/33|34/));
                const isExpanded = this.header.getAttribute('aria-expanded') == 'true';
                // 38 = Up, 40 = Down
                if (key.match(/38|40/) || ctrlModifier) {
                    target.focus();
                }
                if (key === '13') {
                    this.toggle(isExpanded);
                }
            });
        }
    }
    toggle(isExpanded = false) {
        if (this.content) {
            if (!isExpanded) {
                this.header?.setAttribute('aria-expanded', 'true');
                this.header?.classList.remove('text-green-600', 'border-grey-100', 'border-t');
                this.header?.classList.add('text-green-700', 'border-gold', 'border-t-2');
                this.el.classList.add('is-open');
                this.content?.removeAttribute('hidden');
                this.expand(this.content);
            }
            else {
                this.collapse(this.content);
            }
        }
    }
    collapse(element) {
        // get the height of the element's inner content, regardless of its actual size
        const sectionHeight = element.scrollHeight;
        // temporarily disable all css transitions
        const elementTransition = element.style.transition;
        element.style.transition = '';
        // on the next frame (as soon as the previous style change has taken effect),
        // explicitly set the element's height to its current pixel height, so we
        // aren't transitioning out of 'auto'
        requestAnimationFrame(function () {
            element.style.height = sectionHeight + 'px';
            element.style.transition = elementTransition;
            // on the next frame (as soon as the previous style change has taken effect),
            // have the element transition to height: 0
            requestAnimationFrame(function () {
                element.style.height = 0 + 'px';
            });
        });
        this.el.classList.remove('is-open');
        this.header?.classList.remove('text-green-700', 'border-gold', 'border-t-2');
        this.header?.classList.add('text-green-600', 'border-grey-100', 'border-t');
        setTimeout(() => {
            this.header.setAttribute('aria-expanded', 'false');
            element.setAttribute('hidden', '');
        }, 600);
        // mark the section as "currently collapsed"
        element.setAttribute('data-collapsed', 'true');
    }
    expand(element) {
        // Get the height of the element's inner content, regardless of its actual size
        const sectionHeight = element.scrollHeight;
        // have the element transition to the height of its inner content
        element.style.height = sectionHeight + 'px';
        // when the next css transition finishes (which should be the one we just triggered)
        const transitionend = () => {
            // remove this event listener so it only gets triggered once
            element.removeEventListener('transitionend', transitionend);
            // remove "height" from the element's inline styles, so it can return to its initial value
            element.style.height = 'auto';
        };
        element.addEventListener('transitionend', transitionend, false);
        // mark the section as "currently not collapsed"
        element.setAttribute('data-collapsed', 'false');
    }
}
